export enum NavigationTheme {
  WHITE = 'WHITE',
  BLACK = 'BLACK',
  OPAL_BLACK = 'OPAL_BLACK',
  OPAL_WHITE = 'OPAL_WHITE',
}
